export default {
    'PV_COSTS': 29098,
    'KW_CO_2_VAL': 0.45,
    'KW_2_EUR': 0.3325,
};